import { Routes } from "@angular/router";
import { LoggedGuard } from "@auth/guards/logged.guard";
import { WorkspaceHomeComponent as WorkspaceHome } from "@workspace/workspace-home/workspace-home.component";
import {
    AdministrationHomeComponent as AdminHome,
} from "@administration/administration-home/administration-home.component";
import BackendNotAvailableComponent from "@pages/error-pages/backend-not-available/backend-not-available.component";
import NotAuthorizedAppAccessComponent
    from "@pages/error-pages/not-authorized-app-access/not-authorized-app-access.component";
import AccountDeactivatedComponent
    from "@pages/error-pages/account-deactivated/account-deactivated.component";
import {
    AdministrationUbiHomeComponent,
} from "@pages/administration-ubi/administration-home/administration-home.component";
import { RoleGuard } from "@ubisolutions/core";

export const APP_ROUTES: Routes = [
    {
        path: "workspace",
        component: WorkspaceHome,
        loadChildren: () => import("@pages/workspace/workspace.routes"),
        canActivate: [LoggedGuard],
    },
    {
        path: "administration-ubi",
        component: AdministrationUbiHomeComponent,
        loadChildren: () =>
            import("@pages/administration-ubi/administration.routes"),
        canActivate: [RoleGuard],
        data: { roles: ["Administrator", "Support"] },

    },
    {
        path: "administration",
        component: AdminHome,
        loadChildren: () => import("@administration/administration.routes"),
        canActivate: [LoggedGuard],
    },
    {
        path: "not-authorized-app-access",
        component: NotAuthorizedAppAccessComponent,
    },
    {
        path: "account-deactivated",
        component: AccountDeactivatedComponent,
    },
    {
        path: "backend-not-available",
        component: BackendNotAvailableComponent,
    },
    {
        path: "imports",
        loadComponent: () => import("@administration-ubi/pages/import/import.component"),
    },
    {
        path: "**",
        redirectTo: "workspace",
    },
];
